import React, { Component } from 'react';
import { Card, Input } from 'antd';
import OTextField from './../../commons/OTextField';
import { translate } from 'react-i18next';

class PurchaseProcessForm extends Component {
    constructor(props) {
        super(props);
        this.state = { persona: props.persona };
    }

    render() {
        const {t} = this.props;
        return (
        <Input.Group>
        <OTextField container={this.state.persona} fieldName="purchase.objections" label={t('assumption.personal.purchase.objections')}/>
        <OTextField container={this.state.persona} fieldName="purchase.role" label={t('assumption.personal.purchase.role')} />
        </Input.Group>
        );
    }
}

export default translate('translations')(PurchaseProcessForm);


// WEBPACK FOOTER //
// ./src/components/assumptions/profiles/PurchaseProcessForm.js